import * as React from 'react'

import { inject, observer } from 'mobx-react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { ISharedDelivery } from '~/client/graph/types.generated'
import SharedDeliveryActions from '~/client/src/shared/components/SharedEntityActions/SharedDeliveryActions'
import { SharedEntityActionTypes } from '~/client/src/shared/components/SharedEntityActions/SharedEntityActions'
import SharedDeliveriesStore from '~/client/src/shared/stores/domain/SharedDeliveries.store'

import MobileCommonStore from '../../stores/ui/MobileCommon.store'
import { EntitySharedView, defaultHandlers } from './EntitySharedView'

interface IProps {
  common: MobileCommonStore
  sharedDeliveriesStore?: SharedDeliveriesStore
}

interface IRouteParams {
  entityId: string
}

const DeliverySharedView: React.FC<
  IProps & RouteComponentProps<IRouteParams>
> = ({ common, sharedDeliveriesStore, match }) => {
  const handleActionClick = (
    actionType: SharedEntityActionTypes,
    sharedDelivery: ISharedDelivery,
    e: React.MouseEvent,
  ): void => {
    const { responsible, projectUrl, locationsFrom, locationsTo } =
      sharedDelivery
    switch (actionType) {
      case SharedEntityActionTypes.GO_TO_PROJECT:
        defaultHandlers.handleLinkClick(e, projectUrl)
        break
      case SharedEntityActionTypes.GO_TO_TO_LOCATION:
        defaultHandlers.handleLinkClick(e, locationsTo[0].locationUrl)
        break
      case SharedEntityActionTypes.GO_TO_FROM_LOCATION:
        defaultHandlers.handleLinkClick(e, locationsFrom[0].locationUrl)
        break
      case SharedEntityActionTypes.CALL_ADMIN:
        defaultHandlers.handleCallTo(responsible?.phoneNumber)
        break
      case SharedEntityActionTypes.MAIL_ADMIN:
        defaultHandlers.handleMailTo(responsible?.email)
        break
    }
  }

  const renderActions = (): JSX.Element => {
    const sharedDelivery = sharedDeliveriesStore.list.find(
      d => d.id === match.params.entityId,
    )
    if (!sharedDelivery) return null

    return (
      <SharedDeliveryActions
        entity={sharedDelivery}
        companyName={sharedDelivery.companyName}
        onActionClick={handleActionClick}
        projectId={sharedDelivery.projectFromId}
        isMobile={true}
      />
    )
  }

  const handleBackClick = (): void => {
    common.toggleNavBar()
    common.goBack(common.displayDeliveriesView)
  }

  return (
    <EntitySharedView
      common={common}
      sharedDeliveriesStore={sharedDeliveriesStore}
      entityId={match.params.entityId}
      onBackClick={handleBackClick}
      renderActions={renderActions}
    />
  )
}

export default withRouter(
  inject('sharedDeliveriesStore', 'common')(observer(DeliverySharedView)),
)
